import React , {useState } from "react";
import { useSelector } from 'react-redux'
import { TutorCard } from "./TutorCard";
import 'moment/locale/es';
import { Button, Card, CardHeader, CardBody, FormGroup, Form, Row, Col, } from "reactstrap";
import AsyncSelect from 'react-select/async';


var courseApi = require ('../api');

var Utils = require ('Utils') ;


export const  TutorEnrollCard = ( { enroleTutor, closeMe, currentTutors, topLevel  } ) => {

  const [inputValue, setValue] = useState('');
  const [selectedValue, setSelectedValue] = useState(null);

  const { course, token, currentCalendarID, isSaving } = useSelector(state => ({
    currentCalendarID: state.school.currentCalendarID,
    token: state.auth.session.jwt_token, 
    course: state.courses.course,
    isSaving: state.view.loadingModules.enrollingTutor 

   }))

    // handle input change event
    const handleInputChange = value => {
      setValue(value);
    };

   // handle selection
   const handleChange = value => {
    setSelectedValue(value);
    }
 

  const confirmEnroll = () => {
    if (selectedValue) { 
      enroleTutor (token, course.course_id, currentCalendarID, selectedValue.persona_id)
      closeMe(false)
    }
  }

    // load options using API call
    const loadOptions = (inputValue) => {
      // if (inputValue.length >= 3 ) 
      if ( topLevel && ( topLevel==='PRIM' || topLevel==='KIN' ) ) {
        return courseApi.getCourseTutors( token, course.course_id ).then(( res ) => {
          return res.filter( ( tutor ) => !currentTutors.includes(tutor.persona_id) );
        });

       } else {
          return courseApi.getTutors( token ).then(( res ) => {
                  return res.filter( ( tutor ) => !currentTutors.includes(tutor.persona_id) );
                });
      }


    };

        return (
          
        <>
        <Card>
                <CardHeader>
                  <Row>
                    <Col className="pr-1" md="12">
                      <h5 className="title">Agregar 
                              {(topLevel&&( topLevel==='PRIM' || topLevel==='KIN' )?' docente titular ':' preceptor ')}
                                     
                                    a {course.name} - {course.shift_name}</h5>
                    </Col>
                  </Row>
                </CardHeader>
                
                <CardBody>
                  <Form>
                    <Row>
                      <Col className="pr-1" md="12">
                        <FormGroup>
                          <label>Preceptor</label>
                          <AsyncSelect
                              cacheOptions
                              defaultOptions
                              value={selectedValue}
                              getOptionLabel={e => Utils.capitalize( e.last_name + ", " + e.name + " ( " + e.doc_type + ": " + e.doc_nbr + ")"  ) }
                              getOptionValue={e => e.persona_id}
                              loadOptions={loadOptions}
                              onInputChange={handleInputChange}
                              onChange={handleChange}
                              placeholder="Ingrese apellido ... "
                              noOptionsMessage={e => { return (<> No se encontro  <b>{inputValue}</b> </>) } }
                              loadingMessage={e => { if (inputValue.length >= 3 )
                                                        return "Buscando ... "
                                                        else return "ingrese al menos 3 letras del apellido para buscar"
                                                    }
                                              }
                            />
                            {selectedValue &&
                              <>
                                <br /><br />
                                <TutorCard
                                    tutor={selectedValue}
                                />

                              <Button color="success" size="sm" disabled={isSaving}
                                onClick={() => confirmEnroll()}>
                              {isSaving?
                                <i className="nc-icon nc-refresh-69  fa-spin" />
                              :
                              <>
                                <span className="btn-label">
                                  <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                </span>
                                {(topLevel&&( topLevel==='PRIM' || topLevel==='KIN' )?' Confirmar docente titular ':' Confirmar preceptor ')}
                                
                              </>
                              }
                              </Button>
                            </>
                            }

                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              </>
          );
    }

    // 